// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eduCard .customCardbody {\n  margin: -10px 0 20px 0 !important;\n}\n.eduCard2 .customCardbody {\n  padding: 20px 15px 0px 15px !important;\n  margin-bottom: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
